import HttpService from "../services/Http.Service";

async function getDevice(data) {
    return await HttpService.controlServerWithToken("GET", "device", "get_device", data);
}

async function setDeviceStatus(data) {
    return await HttpService.controlServerWithToken("POST", "device", "set_device_status", data);
}

async function createDevice(data) {
    return await HttpService.controlServerWithToken("POST", "device", "create_device", data);
}

async function deleteDevice(data) {
    return await HttpService.controlServerWithToken("POST", "device", "delete_device", data);
}

export { getDevice, setDeviceStatus, createDevice, deleteDevice };
